import {createSelector} from 'reselect'
import {getTimeZoneGroups, getUserGroups, getUserGroupsWithDefault, getUsers} from '../../entities/selectors'
import UserWithAccessRights from '../../store/UserWithAccessRights'
import {userComparator} from '../../usersSelector/user_group_selector_util'
import {createGroupComparator} from '../../util/groupUtils'
import GroupType from '../../enums/GroupType'
import {isTZGEnabled, isAnyTZGEnabled, isAnyUGREnabled, isUGREnabled} from '../../features/selectors'
import Group from '../../store/Group'


export const getDARSettingsState = state => state.darSettings

export const doesAllowUsersToSeeAllTT = state => getDARSettingsState(state).allowUsersToSeeAllTT
export const doesAllowRegularUsersToEditTaskStatuses = state => getDARSettingsState(state).allowRegularUsersToEditTasksStatuses
export const getUsersForSeeAllTTFilter = state => getDARSettingsState(state).usersForSeeAllTTFilter
export const doesShowUsernameInReports = state => getDARSettingsState(state).showUsernameInReports
export const doesHideNotAssignedTTDetails = state => getDARSettingsState(state).hideNotAssignedTTDetails
export const doesHideDetailsOnLockTT = state => getDARSettingsState(state).hideDetailsOnLockTT
export const doesHideAccountSettingsWhenDisabled = state => getDARSettingsState(state).hideAccountSettingsWhenDisabled
export const doesTTMCanSeeAutoApproved = state => getDARSettingsState(state).ttmCanSeeAutoApproved

export const getDARSettings = createSelector(
    getDARSettingsState,
    (darState) => ({
        allowUsersToSeeAllTT: darState.allowUsersToSeeAllTT,
        allowRegularUsersToEditTasksStatuses: darState.allowRegularUsersToEditTasksStatuses,
        usersForSeeAllTTFilter: darState.usersForSeeAllTTFilter,
        showUsernameInReports: darState.showUsernameInReports,
        hideNotAssignedTTDetails: darState.hideNotAssignedTTDetails,
        hideDetailsOnLockTT: darState.hideDetailsOnLockTT,
        hideAccountSettingsWhenDisabled: darState.hideAccountSettingsWhenDisabled,
        ttmCanSeeAutoApproved: darState.ttmCanSeeAutoApproved,
    })
)

export const getUsersList = createSelector(
    getUsers,
    (users) => {
        return Object.values(users).map(u => UserWithAccessRights.fromRPC(u)).sort(userComparator)
    }
)

export const getTimeZoneGroupsList = createSelector(
    getTimeZoneGroups,
    isTZGEnabled,
    (timeZoneGroups, tzgEnabled) => tzgEnabled
        ? Object.values(timeZoneGroups).map(g => new Group(g.id, g.name)).sort(createGroupComparator(GroupType.TIME_ZONE_GROUP))
        : []
)

export const getAnyTimeZoneGroupsList = createSelector(
    getTimeZoneGroups,
    isAnyTZGEnabled,
    (timeZoneGroups, tzgEnabled) => tzgEnabled
        ? Object.values(timeZoneGroups).map(g => new Group(g.id, g.name)).sort(createGroupComparator(GroupType.TIME_ZONE_GROUP))
        : []
)

export const getUserGroupsList = createSelector(
    getUserGroups,
    isUGREnabled,
    (userGroups, ugrEnabled) => userGroupsToList(userGroups, ugrEnabled)
)

export const getUserGroupsListWithDefault = createSelector(
    getUserGroupsWithDefault,
    isUGREnabled,
    (userGroups, ugrEnabled) => userGroupsToList(userGroups, ugrEnabled)
)

export const getAnyUserGroupsListWithDefault = createSelector(
    getUserGroupsWithDefault,
    isAnyUGREnabled,
    (userGroups, ugrEnabled) => userGroupsToList(userGroups, ugrEnabled)
)

export const getDARSettingsCollapsedState = createSelector(
    getDARSettingsState,
    (darSettings) => ({
        allowUsersToSeeAllTTCollapsed: darSettings.allowUsersToSeeAllTTCollapsed,
        allowRegularUsersToEditTasksStatusesCollapsed: darSettings.allowRegularUsersToEditTasksStatusesCollapsed,
        showUsernameInReportsCollapsed: darSettings.showUsernameInReportsCollapsed,
        hideNotAssignedTTDetailsCollapsed: darSettings.hideNotAssignedTTDetailsCollapsed,
        hideDetailsOnLockTTCollapsed: darSettings.hideDetailsOnLockTTCollapsed,
        hideAccountSettingsCollapsed: darSettings.hideAccountSettingsCollapsed,
        ttmCanSeeAutoApprovedCollapsed: darSettings.ttmCanSeeAutoApprovedCollapsed,
    })
)

export const isAllowUsersToSeeAllTTCollapsed = state => getDARSettingsState(state).allowUsersToSeeAllTTCollapsed
export const isAllowRegularUsersToEditTasksStatusesCollapsed = state => getDARSettingsState(state).allowRegularUsersToEditTasksStatusesCollapsed
export const isShowUsernameInReportsCollapsed = state => getDARSettingsState(state).showUsernameInReportsCollapsed
export const isHideNotAssignedTTDetailsCollapsed = state => getDARSettingsState(state).hideNotAssignedTTDetailsCollapsed
export const isHideDetailsOnLockTTCollapsed = state => getDARSettingsState(state).hideDetailsOnLockTTCollapsed
export const isHideAccountSettingsCollapsed = state => getDARSettingsState(state).hideAccountSettingsCollapsed
export const isTtmCanSeeAutoApprovedCollapsed = state => getDARSettingsState(state).ttmCanSeeAutoApprovedCollapsed


const userGroupsToList = (userGroups, ugrEnabled) => ugrEnabled
                                                     ? Object.values(userGroups).map(g => new Group(g.id, g.name))
                                                             .sort(createGroupComparator(GroupType.USER_GROUP))
                                                     : []



// WEBPACK FOOTER //
// ./web/js/administration/darSettings/selectors.js